import { CLOSE_PATAGONIA_ONBOARDING_MODAL, SET_COMMERCE_TASK_GUIDE_MODAL_OPEN, OPEN_PATAGONIA_ONBOARDING_MODAL } from './ActionTypes';
export const openPatagoniaOnboardingModal = () => {
  return {
    type: OPEN_PATAGONIA_ONBOARDING_MODAL
  };
};
export const closePatagoniaOnboardingModal = () => {
  return {
    type: CLOSE_PATAGONIA_ONBOARDING_MODAL
  };
};
export const setCommerceTaskGuideModalOpen = payload => {
  return {
    type: SET_COMMERCE_TASK_GUIDE_MODAL_OPEN,
    payload
  };
};